<template>
    <div class="antialiased">
        <Sidebar />
        <div class="page">
            <Header :disabledSearch="true" />
            <div class="content container">
                <div class="page-header">   
                    <div class="row d-flex justify-content-between">
                        <div class="col-auto">
                            <h2 class="page-title">Laporan Export MARS</h2>
                        </div>
                        <div class="col-auto">
                            <div class="row">
                                <div class="col-auto">
                                    <button :disabled="page.loading" class="btn btn-white" v-html="ic('filter')+' Filter'" @click="isModal"> </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="alert alert-info">
                    <i class="fe fe-info mr-2"></i> Pilih filter untuk memuat data MARS sesuai dengan tanggal yang diinginkan
                </div>
                <div class="page-body" v-if="!page.loading && datas.errors.length == 0">
                    <Nodata v-if="!page.loading && datas.data.length == 0"/>
                    <div class="text-center my-6" v-if="datas.data.length > 0" >
                        <img :src="asset('doc.png')" alt="Icon Export Data" style="width: 200px; opacity: 0.5"/>
                        <h3 class="my-3" v-html="datas.data.length + ' Data'"></h3>
                        <JsonCSV class="btn btn-outline-primary" style="width: 200px; margin: 2px;"
                            delimiter=";"
                            :name="'export_mars_tanggal_'+filters.start_date+'-'+filters.end_date+'.csv'"
                            :data="datas.data"
                            :encoding="utf-7"
                            >Download CSV
                        </JsonCSV>
                    </div>
                </div>
                <transition name="slide-fade-y">
                    <Skeleton v-if="this.page.loading" type="table" :length="10" class="mt-3 bg-white" />
                    <section class="page-body" v-if="datas.errors.length > 0 && !page.loading">
                        <form @submit.prevent="_updateData">
                            <div class="card">
                                <div class="table-responsive overflow-auto" style="max-height: 680px;">
                                    <table class="table table-vcenter table-hover card-table table-striped table-control">
                                        <thead>
                                            <tr class="text-muted">
                                                <td>No</td>
                                                <td class="text-capitalize" v-for="(header) in page.headerTable">{{header.replace('_', ' ')}}</td>
                                                <td>Code</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(data ,index) in datas.errors" :key="index">
                                                <td>{{ ++index  }}</td>
                                                <td v-for="(header) in page.headerTable">{{ data.request[header] }}</td>
                                                <td>
                                                    <input 
                                                        type="text" 
                                                        class="form-control"
                                                        placeholder="Code MARS"
                                                        v-model="data.payload.code"
                                                        required>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="d-flex flex-row-reverse">
                                <button type="submit" class="btn btn-primary ml-2" :key="2">Update Data</button>
                            </div>
                        </form>
                    </section>
                </transition>
            </div>
        </div>
        <FormFilter @submit="_getData" @close="isModal"></FormFilter>
    </div>
</template>
<script>
import helper from "@/assets/js/helper.js";
import FormFilter from './modals/filter.vue'    
import JsonCSV from "vue-json-csv";
import { mapState, mapActions  } from "vuex";

export default {
    name: "ExportMars",
    data(){
        return{
            page:{
                loading: false,
                isSubmit: false,
                headerTable:[]
            }
        }
    },
    components: {
        JsonCSV,
        FormFilter
    },
    mixins: [helper],
    computed: { 
        ...mapState("external_mars",{
            datas: state => state.datas.exportMars,
            filters: state => state.filters.exportMars
        })
    },
    methods: {
        ...mapActions("external_mars",['isModal','getExportMars','mappingUpdate','resetState']),
        async _getData(){
            this.page.loading = true
            await this.getExportMars()
            this.page.headerTable = ['code_type','name']
            this.datas.errors.find(error => {
                if(error.request.code_type === 'CUSTCD'){
                    this.page.headerTable =  Object.keys(error.request)
                }
            })
            this.page.loading = false
        },
        async _updateData(){
            this.page.isSubmit = true
            this.page.loading = true
            await this.mappingUpdate(this.datas.errors)
            this.page.loading = false
            this.page.isSubmit = false
        },
    },
    mounted(){
        this.resetState()
    }
}
</script>